export class AdminApiKey {
	public id:number = 0;
	public name:string  = "";
	public adminId:number = 0;

	public constructor(data?:any){
		if (!data) return;
		this.id = data.id;
		this.name = data.name;
		this.adminId = data.adminId;
	}
}